// Notificação de menção no chat interno (#1750). O primary actor é o CANAL do chat
// (`InternalChat::Channel`), não uma conversa: as telas de notificação tratavam tudo que não era
// tarefa como conversa e, com este tipo, abririam a conversa do atendimento que tivesse o mesmo
// id do canal. Quem decide para onde ir é esta função, uma só para as quatro telas.
//
// Grupo abre o grupo; conversa direta abre a conversa com quem mencionou (o secondary actor).
export const INTERNAL_CHAT_ACTOR = 'InternalChat::Channel';

export const isInternalChatNotification = notification =>
  notification?.primary_actor_type === INTERNAL_CHAT_ACTOR;

export const internalChatRouteFor = (notification, accountId) => {
  if (!isInternalChatNotification(notification)) return null;
  const channel = notification.primary_actor || {};
  if (channel.kind === 'group') {
    return {
      name: 'internal_chat_group',
      params: { accountId, groupId: channel.id },
    };
  }
  const userId = notification.secondary_actor?.id;
  return {
    name: 'internal_chat',
    params: userId ? { accountId, userId } : { accountId },
  };
};
